export type ServerDdeTableResponse = {
  client_id: string;
  datetime_created: string;
  datetime_updated: string;
  dde_model_count?: number;
  document_count: number;
  id: string;
  name: string;
  total_extraction_count?: number;
  user_id: string;
};

export type DdeTable = {
  clientId: string;
  datetimeCreated: string;
  datetimeUpdated: string;
  ddeModelCount?: number;
  documentCount: number;
  id: string;
  name: string;
  totalExtractionCount?: number;
  userId: string;
};

export const mapDdeTable = (response: ServerDdeTableResponse): DdeTable => ({
  clientId: response.client_id,
  datetimeCreated: response.datetime_created,
  datetimeUpdated: response.datetime_updated,
  ddeModelCount: response.dde_model_count,
  documentCount: response.document_count,
  id: response.id,
  name: response.name,
  totalExtractionCount: response.total_extraction_count,
  userId: response.user_id,
});
